module.exports = __webpack_public_path__ + "static/bmw-logo.98a64665.svg";